<template>
  <div class="orderNotes">
  <div class="detail">
    <div class="name">第一条 特别提示
    </div>
    <div class="txt">武汉大方汽车租赁有限公司（以下简称“本公司”）通过大方官网（“大方平台”）为客户进行预订租车服务。
    </div>
    <div class="txt">在通过大方平台向本公司预订开始前，请仔细阅读本须知，本须知及产品页面中的重要条款作为本公司与预订人（下方所称“您”，代以“您”统称承租人和预订人应知晓和遵守的内容）双方协议的重要内容。当您勾选同意并进一步预订租赁产品时，表明您仔细阅读并接受协议的所有条款。请遵守并履行《租车合同》以及注意遵守当地的法律法规。如您与门店签订及履行《租车合同》中更改了在本公司预订中确认的产品和条款，请以您最终签订的《租车合同》为准。
    </div>
    <div class="name">第二条 相关概念注解
    </div>
    <div class="txt">您接受以下概念内涵的注解：
    </div>
    <div class="txt">1．自驾租车产品：国内自驾租车产品是指，本公司为客户预订车辆使用的租车服务。
    </div>
    <div class="txt">2．自驾租车产品开始和结束时间：开始时间以订单上预订的用车时间为准，结束时间以实际结束时间为准，如您用车超过在本公司预订的部分，请您参考不同车型选项说明中的标准，并在还车时依据与门店签署的《租车合同》直接与门店结算。
    </div>
    <div class="txt">3．自驾租车产品建议提前4小时预订，请以收到订单生效通知后确认您已预订到车辆资源。
    </div>
    <div class="txt">4．自驾租车租金基本计费单位：1天（24小时）起租，租期不满24小时，使用时间超过4小时按照1天收费。
    </div>
    <div class="txt">5．费用中不含路桥费、停车费以及因违反交通法规产生的罚款等费用。
    </div>
    <div class="txt">6．以下所说的承租人是指：门店的服务人员；预订人是指：向本公司预订自驾租车产品的人员。
    </div>
    <div class="name">第三条 租车产品价格
    </div>
    <div class="txt">1.本公司保留在不事先知会的情况下随时更改其网站上已公布的自驾租车产品价格的权利。
    </div>
    <div class="txt">2.您预订的自驾租车产品价格以发给您的确认单（手机短信）上约定的金额作为参考，最终价格请以当地租车门店为准。大方给您的确认单上约定的价格，只包括确认单中注明的费用包含项中的内容，其它均不含。
    </div>
    <div class="txt">3.如果您超过确认信息中用车所限定的使用时间或公里数，请您在还车时依据《租车合同》直接与门店结算，您可参考具体产品中相应车型中有关超时超公里的收费标准，租车公司会在还车结算后向您提供相应的收据。
    </div>
    <div class="name">第四条 订单生效
    </div>
    <div class="txt">1.订单生效的定义：产品预订成功后，本公司通过大方平台给您发送确认信息，该订单即生效。
    </div>
    <div class="txt">2.订单生效后，您应按订单中约定的有效时间或时段准时到达约定地点。如您未在约定时间内到达约定地点则视为您主动解约。本公司有权按照本须知第五条的约定要求赔偿。
    </div>
    <div class="name">第五条 您主动取消已生效订单
    </div>
    <div class="txt">订单生效后，您可以在自驾租车活动开始前通知本公司取消您所做预订，取消订单需遵循预订流程中已披露的取消政策，可能依照政策产生相应违约费用。
    </div>
    <div class="name">第六条 更改已生效订单
    </div>
    <div class="txt">除部分支持修改的订单外，订单生效后不可更改，请您仔细阅读订单的修改政策后按照规定修改订单。如订单不可修改，您确实需要更改订单内的任何内容时，请务必在取车前通过大方平台向本公司申请取消订单，再重新下订单。
    </div>
    <div class="name">第七条 租车产品使用权变更
    </div>
    <div class="txt">租车订单生效后不可变更承租人，车辆不可转借给您预订登记中的承租人之外的他人使用或违反合同对车辆作任何处置，如您确实需要将车辆使用权转与他人，请务必取消原有订单，再重新下订单。未经本公司确认同意的使用权转让，我们对可能发生的任何问题不承担任何责任。
    </div>
    <div class="name">第八条 您应履行的义务
    </div>
    <div class="txt">1. 您提供给本公司、大方平台以及门店的预订人及承租人个人信息均应为真实有效，并请在约定时间持确认短信、本人两证一卡（中国居民第二代身份证原件、中华人民共和国机动车驾照，有足够余额的本人的国内信用卡或者门店同意的其他担保方式）前往门店办理租车手续，并与门店签署《租车合同》。
    </div>
    <div class="txt">2.如果您的驾照为国际或外国驾照，根据中国法律需换领中国大陆驾照后方可租车自驾。
    </div>
    <div class="txt">3.在您取车时，门店都将刷取一笔您的信用卡预授权作为租车保证金（免押订单除外）；在您还车时，门店都将刷取一笔您的信用卡预授权作为违章押金（免押订单除外），
如果您租车期间没有违章，在您还车一个月后，这笔费用将自动解冻，归还您信用卡中；如果您租车期间发生违章，门店将会把违章记录提供给您，并协助您处理违章，若您在预授权到期前仍未处理违章，门店将在您的违章押金中按违章金额扣去费用，余额归还信用卡中。
    </div>
    <div class="txt">4.如因客户自身原因导致不能按时取车或还车，应按照提车时与门店签订的《租车合同》执行，您将依据合同承担相应的费用和办理手续，请注意一旦超期未还应立即通知门店，擅自未经许可逾期不还除经济责任外还可能承担相应的治安、行政及刑事责任。
    </div>
    <div class="txt">5.购买基本保障服务和全面保障服务请仔细查看保障范围，请遵守理赔要求，注意不予理赔场景，否则您可能无法享受保障，具体以保险公司条款为准。
    </div>
    <div class="txt">6.请您诚实守信按照约定使用车辆，遵守《租车合同》对使用权转让的约定；如发生不遵守《租车合同》擅自转交、转让、处置该租赁车辆，所发生的任何责任，承租人将与预订人承担连带责任。
    </div>
    <div class="name">第九条 本公司的服务包括：
    </div>
    <div class="txt">1.按照确认订单为您预订车辆。
    </div>
    <div class="txt">2.向您告知提车的具体接洽办法。
    </div>
    <div class="txt">3.严格考评筛选出的具备相关资质的门店向您提供服务，对订单中已经确认的用车车组描述和相关服务描述的准确性负责。
    </div>
    <div class="txt">4.本公司仅负责租车产品因预订环节产生的相关事宜，租车合同履行中发生的相关事件及纠纷，包括但不限于，交通事故、第三者责任、车辆急修援助、保险理赔罚金、延期还车等其他事宜，由客户（承租人）和门店（出租人）按照其双方签署的书面租车协议协商解决，本公司不承担租赁车辆因任何事故造成的任何后果。
    </div>
    <div class="txt">5. 如您与门店签署《租车合同》自行变更了本公司的订单，请以您签署的合同为准，本公司无法为您自行变更的事项负责。
    </div>
    <div  v-if="false"> 
      <div class="name">第十条 不可抗力
      </div>
      <div class="txt">因不可抗力(包括地震、台风、雷击、水灾、火灾等自然原因，以及战争、政府行为、黑客攻击、电信部门技术管制等原因)不能履行或不能继续履行已生效订单约定内容的，本公司和您均不承担违约责任，但法律另有规定的除外。
      </div>
      <div class="txt">因本公司延迟为已生效订单服务后发生不可抗力的，不能免除责任。
      </div>
      <div class="name">第十一条 争议解决
      </div>
      <div class="txt">在您的预订生效后，如果在本须知或订单约定内容履行过程中，您对相关事宜的履行发生争议，您只同意按照中华人民共和国颁布的相关法律法规来解决争议。凡因本合同引起的或与本合同有关的任何争议，均应提交武汉仲裁委员会按照该会仲裁规则进行仲裁。仲裁裁决是终局的，对双方当事人均有约束力。
      </div>
      <div class="name">第十二条 其它
      </div>
      <div class="txt">本须知未尽的其他事项，由双方协商解决。
      </div>
    </div>
    <div v-if="true">
      <div class="name">第十条 芝麻信用授权
      </div>
      <div class="txt">
      为更好的享受大方租车提供的服务，本人知晓并同意芝麻信用有权基于提供征信服务的需要向合法保存有本人信息的机构采集本人信息（包括由大方租车有权将本人在使用其服务过程中提交或产生的信息提供给芝麻信用），用于验证本人信息的真实性及提供征信服务使用。本人授权芝麻信用，可根据大方租车的查询指令，向其提供相关信息的真实性判断结果及本人的信用信息，用以交易决策使用。
      </div>
      <div class="name">第十一条 不可抗力
      </div>
      <div class="txt">因不可抗力(包括地震、台风、雷击、水灾、火灾等自然原因，以及战争、政府行为、黑客攻击、电信部门技术管制等原因)不能履行或不能继续履行已生效订单约定内容的，本公司和您均不承担违约责任，但法律另有规定的除外。
      </div>
      <div class="txt">因本公司延迟为已生效订单服务后发生不可抗力的，不能免除责任。
      </div>
      <div class="name">第十二条 争议解决
      </div>
      <div class="txt">在您的预订生效后，如果在本须知或订单约定内容履行过程中，您对相关事宜的履行发生争议，您只同意按照中华人民共和国颁布的相关法律法规来解决争议。凡因本合同引起的或与本合同有关的任何争议，均应提交武汉仲裁委员会按照该会仲裁规则进行仲裁。仲裁裁决是终局的，对双方当事人均有约束力。
      </div>
      <div class="name">第十三条 其它
      </div>
      <div class="txt">本须知未尽的其他事项，由双方协商解决。
      </div>
    </div>
  </div>
</div>
</template>
<script>
// import { orderSource } from "@/utils/env";
export default {
  name: "orderNotes",
  data() {
    return {
      orderSource: 12,
      isShowNotes: false
    };
  },
  props: [],
  methods: {
    showContNotes() {
      this.isShowNotes = true;
    },
    hideContNotes() {
      this.isShowNotes = false;
    }
  }
};
</script>

<style lang="scss" scoped type="text/scss">
.orderNotes {
    width: 100%;
    font-size: 22px;
    background-color: #fff;
    .detail {
      padding: 20px 30px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      color: gray;
      overflow: scroll;
      .title {
        margin-top: 20px;
        margin-bottom: 5px;
        font-weight: bold;
        color: #0000ff;
      }
      .name {
        margin-top: 20px;
        margin-bottom: 5px;
        font-weight: bold;
      }
      .txt {
        margin-bottom: 15px;
        line-height: 45px;
        text-align: justify;
      }
    }
}
</style>

